function convertWeight(weight: number) {
  return weight * 1000;
}

export default convertWeight;
